// jQueryプラグイン

export function serviceFunc() {
  let serviceTop = $('#serviceTop').length;

  let resizecheck = $('#responsibleCheck').width();

  $(window).on('resize', function () {
    resizecheck = $('#responsibleCheck').width();
  });

  if(serviceTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));
    
    function serviceCommonAnimeFunc() {
      $('.pageEntrance').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.pageEntranceTit').hasClass('isShow')) {
                $(this).find('.txtBox').addClass('isShow');
                $(this).find('.pageEntranceTit').addClass('isShow');
                $(this).find('.pageEntranceSubTit').addClass('isShow');
                $(this).find('.pageEntranceTxt').addClass('isShow');
                $(this).find('.pageEntranceBtnArea').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }

    serviceCommonAnimeFunc();

    $(window).on('load scroll', function () {
      serviceCommonAnimeFunc();
    });
  }
}